export const DEFAULT_HIDE_DURATION = 6 * 1000;
export const DEFAULT_TOAST_LIMIT = 3;
